import React from "react";

import { SettingsConfirmModal } from "../../../../../components/modal/SettingsConfirmModal";
import { TrashSvg } from "../../../../../components/svg/TrashSvg";
import { useGetTemplateUsageQuery } from "../../../../../slices/TemplatesSlice";
import { templateDeleteText } from "../model/templateDelete.utils";

type Props = {
  templateId: string;
  templateName: string;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/** Delete-template confirmation that says how many work items use it (QA batch 12). */
export const TemplateDeleteConfirm: React.FC<Props> = ({
  templateId,
  templateName,
  isDeleting,
  onClose,
  onConfirm,
}) => {
  const { data, isFetching } = useGetTemplateUsageQuery(templateId, {
    skip: !templateId,
  });

  return (
    <SettingsConfirmModal
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isDeleting || isFetching}
      icon={<TrashSvg />}
      title={`Delete ‘${templateName}’ template?`}
      description={templateDeleteText(isFetching ? undefined : data?.workItems)}
      confirmText={"Delete"}
      variant={"danger"}
    />
  );
};
